// Purpose: session-scoped record that the user acknowledged the current
// system-use notice before the SSO redirect. Version-aware: a stored ack
// for an older notice version does not count for a newer one.

export const ACK_KEY = 'ast.systemuse.ack';

export function recordSystemUseAck(version: string): void {
  try {
    sessionStorage.setItem(ACK_KEY, version);
  } catch {
    // sessionStorage unavailable (private mode / disabled): the gate still
    // blocks in-memory for this mount; acking is best-effort.
  }
}

export function hasAckedSystemUse(version: string): boolean {
  try {
    return sessionStorage.getItem(ACK_KEY) === version;
  } catch {
    return false;
  }
}
